export default "/images/institution.svg?70084befdb9641623e6511ab2e69b9d8";